import React, {useEffect, useState} from 'react';
import {Box, Typography} from "@mui/material";

function CenterMessage({message, height}) {
  return (
      <Box sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          height: height || 250,
            width: "100%",
      }}>
          <Typography variant={"h6"}>
              {message}
          </Typography>
      </Box>
  )
}

export default CenterMessage